import { SideBarHTML } from "./components/SideBarHtml";

type SideBarProps = {
    children: React.ReactNode;
};

export const SideBar = ({ children }: SideBarProps) => {
    return <SideBarHTML>{children}</SideBarHTML>;
};
